<template>
    <div>
        <v-modal-contents ref="modal_contents_agree">

            <template v-slot:close>
                <!--        убираем close-->
                <div></div>
            </template>

            <template v-slot:title>

                <div class="terms_of_use__title ">
                    <div class="h2_title">Условия использования персональных данных</div>

                </div>

            </template>
            <template v-slot:content>
                <div class="terms_of_use mt-30 ">
                    <div v-html="terms"></div>
                    <div class="mt-30">
                        <button class="px-30 btn-red "
                                @click="$refs.modal_contents_agree.modal_open()">
                            Прочитал
                        </button>

                    </div>
                </div>
            </template>
        </v-modal-contents>
        <v-form ref="form" class=" formNew_wrap wow fadeIn" data-wow-delay="0.3s" v-model="valid" lazy-validation>

            <div class="row mx-0 my-0">
                <slot name="description">
                    <div class="col-12 col-md-6 col-lg-6 p-md-2">
                    </div>
                </slot>
                <div class="col-12 col-md-6 col-lg">
                    <div class="row">

                        <div class="col-12 col-md-6 pb-3 px-3 pt-3">
                            <div class="formNew_wrap__item">

                                <v-text-field
                                        v-model="name"
                                        :rules="[rules.required, rules.ruleTownName]"
                                        required=""
                                        class="form__input"
                                        id="name"
                                >

                                    <template v-slot:label>
                                        ФИО *
                                    </template>
                                </v-text-field>


                            </div>
                        </div>
                        <div class="col-12 col-md-6 pb-3 px-3 pt-3">
                            <div class="formNew_wrap__item">
                                <v-text-field
                                        v-model="company"
                                        :rules="[ rules.ruleOrg]"
                                        class="form__input"
                                        id="company"

                                >
                                    <template v-slot:label>
                                        Компания
                                    </template>
                                </v-text-field>
                            </div>
                        </div>

                        <div class="col-12 col-md-6 pb-3 px-3 pt-3">
                            <div class="formNew_wrap__item">
                                <v-text-field class="form__input"
                                              v-model="email"
                                              :rules="[rules.mail]"
                                              oninput="this.value = this.value.trim()"
                                              id="email"
                                >
                                    <template v-slot:label>
                                        Электронная почта
                                    </template>
                                </v-text-field>

                            </div>
                        </div>
                        <div class="col-12 col-md-6 pb-3 px-3 pt-3">
                            <div class="formNew_wrap__item item_tel position-relative">
                                <!--            this.value = this.value.replace(/^8/, '');-->
                                <!--            oninput="this.value = this.value.replace(/[^\d]/g,''); this.value = this.value.slice(0,10);this.value = this.value.replace(/^\(?8\)?/, '')"-->
                                <v-text-field
                                        v-model="tel_input"
                                        :rules="[rules.required]"
                                        required
                                        id="tel"
                                        oninput="this.value = this.value.replace(/^\(8/, '(');"
                                        class="pl-0 form__input"
                                        max="20"
                                        v-mask="'# ### ###-##-##'"
                                >

                                    <template v-slot:label>
                                        Телефон *
                                    </template>
                                </v-text-field>


                            </div>
                        </div>


                        <div class="col-12 col-md-12 pb-3 px-3 pt-3">
                            <div class="formNew_wrap__item">
                                <v-textarea
                                        v-model="message"
                                        rows="3"
                                        class="form__input"
                                        id="message"

                                >
                                    <template v-slot:label>
                                        Комментарий
                                    </template>
                                </v-textarea>
                            </div>
                        </div>
                        <div class="col-12 col-md-12 pb-3 px-3 pt-3">
                            <!-- SmartCaptcha -->
                            <div id="captcha-container" :class="captchaPassed ? '':'error-captcha'"
                                 class="w-100 mt-30"></div>
                            <div class="formNew_wrap__item  mt-30">
                                <v-checkbox
                                        v-model="checkbox"
                                        :rules="[(v) => !!v || 'Это обязательный пункт']"
                                        required
                                        color="red"
                                >
                                    <template v-slot:label>
                                        <div class="customLabelForm">
                                            Я выражаю согласие с <a href="javascript:void(0);" target="_blank"
                                                                    @click="$refs.modal_contents_agree.modal_open('scroll_false')">условиями
                                            использования</a> моих персональных данных для обработки данного обращения
                                            ООО «Компания Нова Ролл» (ИНН 5038050970, адрес: 141206, Московская область,
                                            г. Пушкино, Кудринское шоссе, д. 2а, стр. 5, этаж 2), я ознакомлен и выражаю
                                            согласие с
                                            <a :href="policy" @click="linkOpen(policy)" class="position-relative zi-1">Политикой
                                                конфиденциальности</a> и <a :href="agreement"
                                                                            @click="linkOpen(agreement)"
                                                                            class="position-relative zi-1">Пользовательским
                                            соглашением.</a>
                                        </div>
                                    </template>
                                </v-checkbox>

                                <v-checkbox
                                        v-model="consentToInform"

                                        color="red"
                                        class="mt-0"
                                >
                                    <template v-slot:label>
                                        <div class="customLabelForm">
                                            Я выражаю согласие на информирование меня о продуктах, акциях, выгодных
                                            предложениях, новостях ООО «Компания Нова Ролл» (ИНН 5038050970, адрес:
                                            141206, Московская область, г. Пушкино, Кудринское шоссе, д. 2а, стр. 5,
                                            этаж 2) и
                                            партнеров.
                                        </div>
                                    </template>
                                </v-checkbox>

                                <div class="btn_form d-flex align-items-center  ">
                                    <v-btn :disabled="!valid" class=" btn-red w-mc"
                                           @click="sendForm">
                                        Отправить
                                    </v-btn>

                                    <!--            <v-btn color="error" class="mr-4" @click="reset"> Reset Form</v-btn>-->

                                    <!--            <v-btn color="warning" @click="resetValidation"> Reset Validation</v-btn>-->
                                </div>
                            </div>

                        </div>

                    </div>
                </div>

            </div>

        </v-form>
    </div>

</template>
<script>
import VModalContents from "./modal_contents";
import {mask} from 'vue-the-mask';

export default {
    components: {
        VModalContents: VModalContents,
    },
    directives: {mask},
    name: "formNewMain",
    props: {
        // lang: Array | String | Number | Boolean | Object,
        // directions: Array | String | Number | Boolean | Object,
        policy: String | Boolean,
        agreement: String | Boolean,
        terms: String | Boolean,
        product: String | Boolean | Number,
        page: String | Boolean,
        iblock: String | Boolean | Number,
    },
    delimiters: ["${", "}"], // Avoid Twig conflicts
    data() {
        return {
            captchaPassed: false,

            valid: true,

            rules: {
                required: value => !!value || 'Обязательное поле',
                ruleOrg: value => {
                    const patternOn = /[~`@#$%^*={}\[\];:<>.,\/\\-_]/g
                    return !patternOn.test(value) || 'Неккоректный ввод'
                },

                ruleProd: value => {
                    const patternPd = /[~`@#$%^*={}\[\];:<>.,\/\\-_]/g
                    return !patternPd.test(value) || 'Неккоректный ввод'
                },

                ruleTownName: value => {
                    const patternSp = /[~`!@№#$%^&*()+={}\[\];:\'\"<>.,]|[0-9_]/g
                    return !patternSp.test(value) || 'Неккоректный ввод'
                },

                mail: value => {
                    if (!value) return true;
                    const pattern = /^(([^<>()[\]\\{\/№%^!#/$?*~+=.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/
                    return pattern.test(value) || 'Неккоректная электронная почта'
                },

                phone: value => {
                    const pattern = /^\+?[1-9][0-9]{7,14}$/
                    return pattern.test(value) || 'Некорректный телефон'
                }
            },
            name: "",
            email: "",
            company: "",
            tel_input: "",
            message: '',
            checkbox: false,
            consentToInform: false,


        };
    },

    methods: {

        linkOpen(url) {
            window.open(url, '_blank');
        },
        // Captcha
        initCaptcha() {
            window.smartCaptcha.render('captcha-container', {
                sitekey: 'ysc1_PUekBeYtvyneoIe4lOZeV4coxdETZmtFUf5aFClW81ba7cd1',
                callback: this.onCaptchaSuccess,
            });
        },
        onCaptchaSuccess(token) {
            this.captchaPassed = true;
            this.form.captchaToken = token;
        },
        // Captcha end
        sendForm() {
            if (!this.$refs.form.validate()) return false;
            if (!this.captchaPassed) {
                this.valid = false;
                return false;
            } else {
                this.valid = true;
            }
            /** AJAX */
            var VueObject = this;
            var formData = new FormData();


            let newTel = VueObject.tel_input;
            if (newTel[0] === '7') {
                newTel = "+ " + newTel; // если первая цифра 7, добавляем +
            }
            console.log(newTel);

            formData.append("name", VueObject.name);
            formData.append("phone", newTel);
            formData.append("email", VueObject.email);
            formData.append("company", VueObject.company);
            formData.append("comment", VueObject.message);
            formData.append("product", VueObject.product);
            formData.append("page", VueObject.page);
            formData.append("iblock", VueObject.iblock);
            formData.append("ajaxPost", "Y");
            console.log(formData);
            $.ajax({
                "type": "POST",
                "url": "/ajax/formNew_form.php",
                "data": formData,
                "cache": false,
                "dataType": 'json',
                "processData": false, // Не обрабатываем файлы (Don't process the files)
                "contentType": false, // Так jQuery скажет серверу, что это строковой запрос
                "success": function (res) {
                    if (VueObject.page == "https://packaging.novaroll.ru/zhestkaya-upakovka/konteyner-polimernyy/") {
                      ym(88483883, 'reachGoal', 'Successful form completion');
                      console.log("metrika has been sent");
                      console.log('pageCheck', 'thisPage '+VueObject.page);
                    } else if (VueObject.page == "https://packaging.novaroll.ru/gibkaya-upakovka/plenka-dlya-zapayki-lotkov/") {
                      ym(88483883,'reachGoal','Sendform');
                      console.log("metrika has been sent");
                      console.log('pageCheck', 'thisPage '+VueObject.page);
                    } else {
                      console.log('pageCheck', 'notThisPage');
                    }
                    console.log(res);
                    $(".text_result").slideDown(300);
                    $(".text_result").delay(3000).slideUp(300);
                    VueObject.$refs.form.reset();
                    setTimeout(function () {
                        window.location.reload()
                    }, 3000);
                },
                "error": function (xhr, ajaxOptions, thrownError) {
                    console.log(xhr.status);
                    console.log(thrownError);
                },
            });
        },
        reset() {
            this.$refs.form.reset();
        },
        resetValidation() {
            this.$refs.form.resetValidation();
        },

    },
    created() {
        setTimeout(() => {
            this.initCaptcha();
        }, 500)
    },
    watch: {
        captchaPassed() {
            // this.sendForm();
            if (!this.captchaPassed) {
                this.valid = false;
                return false;
            } else {
                this.valid = true;
            }
        },
    },
};
</script>

<style lang="scss">
@import "../../theme/_variable.scss";

.wrapp_formNew.v-menu__content {
  margin-top: 51px;

}

.formNew {
  @media(max-width: 576px) {
    margin-top: 10px;
  }

  .smart-captcha {
    min-width: 220px;
  }

  .smart-captcha.error-captcha:before {
    color: #FA4237;
    transform: translateY(-8px);

  }

  .v-text-field .v-label {
    background: #ffffff;
    height: 22px;
    width: 100%;
    color: #404040;
  }

  .v-btn:not(.v-btn--round).v-size--default {
    height: unset;
  }

  h2.formNew_h2 {
    font-family: "MuseoSansCyrl-500";
    font-weight: 400;
    font-style: 500;
    font-size: 52px;
    leading-trim: NONE;
    line-height: 68px;
    letter-spacing: -1.04px;
    vertical-align: middle;

    @media (max-width: 1000px) {
      font-size: 46px;
      line-height: 56px;
    }

    @media (max-width: 650px) {
      font-size: 38px;
      line-height: 44px;
    }

    @media (max-width: 500px) {
      font-size: 30px;
      line-height: 36px;
    }

  }

  .formNew_p {
    font-family: 'RobotoRegular';
    font-weight: 400;
    font-size: 32px;
    line-height: 40px;
    letter-spacing: 0px;
    color: #212424;
    margin: 0;
  }

  .formNew_link {
    font-family: 'MuseoSansCyrl-500';
    font-weight: 400;
    font-size: 52px;
    line-height: 68px;
    letter-spacing: -1.04px;
    color: #212424 !important;
  }

  .formNew__list {

    svg {
      width: 20px;
      min-width: 20px;
      margin-top: 4px;
    }
  }

  & .formNew_wrap__item .primary--text {
    color: #656565 !important;
    caret-color: #656565 !important;
  }

  ul li,
  & p {
    color: rgb(40, 40, 40);
    font-size: 20px;
    font-family: "RobotoRegular";
    font-weight: 400;
    line-height: 24px;
    letter-spacing: 0px;
    text-align: left;
    @media(max-width: 768px) {
      font-size: 18px;
    }
    @media(max-width: 576px) {
      font-size: 16px;
    }
  }

  & .formNew_wrap .theme--light.v-btn.v-btn--has-bg[disabled="disabled"] {
    background: radial-gradient(50% 50% at 50% 50%, rgb(176 176 176 / 80%) 0%, #c1b8b8 100%) !important;

    & .v-btn__content {
      color: white;
    }
  }

  & .formNew_wrap__item ul {
    list-style: none;
    margin-left: 22px;
  }

  & .v-text-field__details {
    position: absolute;
    display: flex;
    transform: translate(-1px, 38px);
  }


  & form.formNew_wrap {
    box-sizing: border-box;
    border: 1px solid rgb(242, 242, 242);
    border-radius: 30px;
    background: #F5F5F7;
    padding: 20px 20px;

    @media (max-width: 425px) {
      padding: 10px;
    }
  }

  & .formNew_wrap .tel_sel__btn {
    width: max-content;
    height: 0;
    position: absolute;
    top: 32px;
    background: none;
    margin-left: 15px !important;
  }

  & .form__input {
    width: auto;
    border: 1px solid #E2E2E2;
    border-radius: 6px;
    padding: 25px 15px !important;
    margin: 0 !important;
    font-weight: 400;
    font-size: 14px;
    line-height: 100%;
    color: #282828;
    resize: none;
    background: #FFFFFF;
  }

  & .v-input__slot {
    margin: 0 !important;

    &::before {
      display: none !important;
    }

    &::after {
      display: none !important;
    }
  }
}

.customLabelForm {
  & a {
    text-decoration: underline transparent;
    transition: all 0.2s ease;

    &:hover {
      text-decoration: underline #FA4237;
    }
  }
}

.v-input.tel_input.form__input.v-input--is-focused .v-label,
.v-input.tel_input.form__input.v-input--is-label-active .v-label--active {
  display: none;
}

.v-list-item {
  @media (max-width: 766px) {
    margin-bottom: 10px;
  }
}

.v-application .v-input--is-focused {
  border-color: #4F4D55;
}

.v-application .error--text {
  border-color: #ff5252 !important;
}
</style>